import React from "react";

export default function ScoreCard(props) {
  return (
    <div className="relative lg:left-48 bg-slate-200 h-[500px] w-full lg:w-2/3 mt-12 rounded-md mb-6">
      <div className="bg-gradient-to-r from-violet-600 to-indigo-600 h-full w-full lg:w-1/2 rounded-md ">
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 lg:left-48 text-sm font-bold text-white">
          Total Score
        </div>
        <div className="absolute bottom-3 right-5 text-sm font-bold text-violet-800">
          Score Card
        </div>
        <div className="relative top-16 mx-auto lg:left-1 w-32 h-32 lg:w-48 lg:h-48 bg-gradient-to-r from-violet-500 to-indigo-500 rounded-full">
          <div className="p-5 text-5xl lg:text-7xl font-semibold text-center text-white">
            {props.finalScore}
            <div className="text-xs lg:text-sm">of 90</div>
          </div>
        </div>
        <div className="relative border-t-2 top-20 lg:top-24 w-48 lg:w-60 mx-auto lg:left-1">
          <div className="text-center text-2xl lg:text-4xl font-bold text-slate-50 p-2 mt-2">
            {props.remarks}
          </div>
        </div>
      </div>
      <div className="absolute top-64 left-1/2 transform -translate-x-1/2 lg:right-8 lg:mx-6 lg:top-14 lg:translate-x-0 flex flex-col w-64 lg:w-80">
        <div className="bg-blue-100 p-3 mt-3 text-blue-600">
          Content
          <span className="text-gray-800 ml-24 lg:ml-40 font-bold">{props.contentScore}/90</span>
        </div>
        <div className="bg-green-100 p-3 mt-3 text-green-600">
          Fluency
          <span className="text-gray-800 ml-24 lg:ml-40 font-bold">{props.fluencyScore}/90</span>
        </div>
        <div className="bg-violet-200 p-3 mt-4 text-violet-600">
          Pronunciation
          <span className="text-gray-800 ml-16 lg:ml-28 font-bold">{props.pronounctionScore}/90</span>
        </div>
      </div>
    </div>
  );
}